import React from 'react';
import { Link } from 'react-router-dom';

import Footer from '../../components/layout/Footer';
import PublicNavbar from '../../components/layout/PublicNavbar';
import Button from '../../components/ui/Button';

export default function ArtPage() {
  return (
    <div className="overflow-x-hidden bg-white text-gray-900">
      <PublicNavbar />
      <main className="mx-auto max-w-5xl px-6 pb-20 pt-32">
        <Link to="/" className="text-sm text-green-700 hover:text-green-800">
          ← Back to Atharva
        </Link>
        <span className="ml-3 inline-flex items-center gap-2 rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-amber-700">
          Heritage · Coming 2026
        </span>
        <h1 className="mt-6 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Village Art &amp; Culture
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-gray-600">
          Preserving and celebrating rural art forms, crafts, and cultural heritage — creating
          livelihood for local artisans through modern markets.
        </p>
        <p className="mt-10 text-sm text-gray-500">
          Detailed project page launching alongside the initiative in 2026.
        </p>
        <div className="mt-8 flex gap-3">
          <a href="mailto:partner@atharva.org">
            <Button>Express interest</Button>
          </a>
          <Link to="/">
            <Button variant="secondary">Back to home</Button>
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
